import React, { useEffect } from "react";
import { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import WidgetWalls from "./Component/Widget_Walls";
import { openCreateNewWallPopup, WIDGET_WALLS_DATA } from "../../../../actions/wallsAction";
import { useDispatch } from "react-redux";
import CreateWall from "../Dashboard/components/common/createWall";

function Walls() {

  const { wallReducer, userData } = useSelector(state => ({ wallReducer: state.wallReducer, userData : state.authenticated.userData}),shallowEqual)
  const widgetWallsData = wallReducer.widgetWallsData;

  const dispatch = useDispatch();
  const [upgrade, setUpgrade] = React.useState(false);
  const [modalData, setModalData] = React.useState({ profanity: 0, modalShow: false, name: "", url: "", wall_id: null, autoUpdate: 1, rename_status: 0 });
  const [updateWall, setupdateWall] = useState(0);

  let collaboratorRole = JSON.parse(localStorage.getItem('isCollaborator'));
  const clickToUpdateState = (data) => event => {  
    
    dispatch(openCreateNewWallPopup(false))
     const widgetCount = (widgetWallsData && widgetWallsData.length) ? widgetWallsData.length : 0;
    if (widgetCount < userData.UserRule.walls || data.rename_status == 1) {
      setModalData(data)
    } else {
       setUpgrade(true)
    }
  }
  
  useEffect(() => {
    const widgetCount = (widgetWallsData && widgetWallsData.length) ? widgetWallsData.length : 0;
    if (widgetWallsData == null) return
    if (widgetCount < userData.UserRule.walls) {
      setModalData({ ...modalData, modalShow: wallReducer.createNewWall })
    } else {
      setUpgrade(wallReducer.createNewWall)
    }
  }, [widgetWallsData])


  useEffect(() => {
    dispatch(WIDGET_WALLS_DATA());
  }, []);


  return (
    <>

      <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
          <div className="walls_screen">
            <div className="subheader subheader_main fixed_subheader subheader-transparent dual_subheader" id="kt_subheader">
              <div className=" container-fluid  d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                <div className="d-flex align-items-center flex-wrap me-1 w-100 justify-content-between">
                  <div className="d-flex align-items-baseline flex-wrap me-3">
                    <h5 className="text-dark font-weight-bolder my-3">
                      My Walls
                    </h5>
                  </div> 
                  <CreateWall widgetWallsData={widgetWallsData}  modalData={modalData} upgrade={upgrade} clickToUpdateState={clickToUpdateState} setUpgrade={setUpgrade} setupdateWall={setupdateWall} setModalData={setModalData} isCollaboratorRole={collaboratorRole} />
                </div>

                {!userData.UserPlan.planId.includes(1) && 5 == 6 ?
                  <div className="d-flex align-items-center">
                    <span className="me-3 font-weight-bolder">Real Time Update</span>
                    <span className="switch">
                        <label className="realTime d-flex" onClick={() => !userData.UserPlan.planId.includes(28, 29, 42, 31, 32, 52) ? '' : ''}>
                          <input type="checkbox" name="createWidget" data-factors-input-id="noform.field-0" />
                          <span/>
                        </label>
                    </span>
                  </div> 
                  : null}

              </div>
            </div>

            <div className="d-flex flex-column-fluid main_content subheader_content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="screen_wrapper px-3">
                      <div className="commerce_conetnt">
                        <div className="dash_walls">  
                          <WidgetWalls wallReducer={wallReducer} userData={userData} updateWall={updateWall} clickToUpdateState={clickToUpdateState} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  );
}

export default Walls;
